import React from 'react';

const NullInput = () => {
    return (
        <div>
            Error
        </div>
    );
}

export default NullInput;